import { render, staticRenderFns } from "./InvoiceDescription.vue?vue&type=template&id=5bca5c2a"
import script from "./InvoiceDescription.vue?vue&type=script&lang=js"
export * from "./InvoiceDescription.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDescription.vue?vue&type=style&index=0&id=5bca5c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports